// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3xqyJ","errorLogs":"EditorFooter_errorLogs__1LIi4"};